module.exports = __webpack_public_path__ + "static/elf_logo-20398856096580a9980abaa7de3f60e9.png";